import React, { useState } from "react";
import ToolsCmp from "../loan/toolsCmp";
import SettlementPaymentTableCmp from "./settlementPaymentTableCmp";
import DuringPaymentTableCmp from "./duringPaymentTableCmp";
import { getTokenClaims } from "../../services/auth.service";
import ErrorPage from "../errorPage/errorPage";

export default function DuringPayment() {
  const [isShow, setIsShow] = useState(true);
  const [exportExcel, setExportExcel] = useState(false);
  const hasWalletAccess = String(getTokenClaims()?.hasWalletAccess);
  return (
    <>
      {hasWalletAccess == "True" ? (
        <div>
          {/* <ToolsCmp
               setIsShow={setIsShow}
               isShow={isShow}
               setExportExcel={setExportExcel}
               isCartable={true}
               showFilter={false}
           /> */}
          <br />
          <DuringPaymentTableCmp
            isShow={isShow}
            setExportExcel={setExportExcel}
            exportExcel={exportExcel}
          />
        </div>
      ) : (
        <ErrorPage />
      )}
    </>
  );
}
